<template>
  <a-modal
    :visible="visible"
    title="Dashboard de campaña"
    :bodyStyle="bodyStyle"
    width="40em"
    centered
    @cancel="$emit('onClose')"
    :footer="null"
  >
    <!--Card de saldo de whatsapp-->
    <p class="regular-14 mrg-bottom-12">
      Recuerda que los datos mostrados a continuación están basados a partir de
      los registros válidos .
    </p>
    <a-row class="modal__card" type="flex">
      <social-icon :type="wallet.channel" class="mrg-right-12" />
      <div class="modal__card-container">
        <h6 class="semibold-12 mrg-bottom-4">Saldo de {{ wallet.channel }}</h6>
        <a-row type="flex" justify="space-between" align="middle">
          <p class="mrg-bottom-0">
            <strong class="semibold-16">{{ wallet.spent }}</strong>
            gastado en esta campaña
          </p>
          <a-divider type="vertical" />

          <p class="mrg-bottom-0">
            <strong class="semibold-16">{{ wallet.available }}</strong>
            disponible
            <span>
              <router-link :to="{ name: 'shop' }" target="_blank"
                >Recargar</router-link
              >
            </span>
          </p>
        </a-row>
      </div>
    </a-row>
    <underline-title
      title="Detalle de plantillas enviadas"
      tipography="semibold-14"
      class="modal__subtitle"
    />
    <a-row
      type="flex"
      align="middle"
      justify="space-between"
      class="modal__container-total"
    >
      <p class="regular-14 mrg-bottom-0">Total de plantillas: {{ total }}</p>
      <a-button @click="handleGetData" :disabled="disabledGetData">
        <a-icon type="sync" :spin="spin" />Traer datos recientes
      </a-button>
    </a-row>
    <PolarChart :styles="myStyles" :chartdata="chartdata" />
    <basic-footer
      okIcon="download"
      okText="Descargar dashboard"
      cancelText="Cancelar"
      @onCancel="$emit('onClose')"
      @onOk="exportValidStrategyRecords(dataSource._id)"
    />
  </a-modal>
</template>

<script>
import SocialIcon from '@/app/shared/components/icons/SocialIcon'
import UnderlineTitle from '@/app/settings/components/organisms/alertsMenu/UnderlineTitle'
import PolarChart from '@/app/dashboard/components/organisms/charts/PolarChart.vue'
import BasicFooter from '@/app/shared/components/molecules/BasicFooter'
import { mapActions } from 'vuex'

export default {
  name: 'ModalDashboard',
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false,
    },
    wallet: {
      type: Object,
      required: true,
    },
    dataSource: {
      type: Object,
      required: true,
    },
  },
  components: {
    SocialIcon,
    UnderlineTitle,
    PolarChart,
    BasicFooter,
  },
  data: () => ({
    bodyStyle: {
      padding: '32px 40px 80px',
    },
    myStyles: {
      height: '300px',
      position: 'relative',
    },
    spin: false,
    disabledGetData: false,
  }),
  computed: {
    /**
     * @return {String} total de plantillas
     */
    total() {
      if (!this.dataSource || !this.dataSource.stats_import) return 0
      return this.dataSource.stats_import.successes
    },
    /**
     * Estados para la campañas, usados solo para el dashboard
     * @return {Objec[]}
     * @return {String} label - nombre del estado
     * @return {Number} order - orden del estado
     * @return {Number} quantity - cantidad de plantillas enviadas por estado
     * @return {String} status - estado de la campaña
     */
    statuses() {
      const arr = []
      const statuses = { ...this.dataSource.stats_send }
      delete statuses.total_sent
      for (let property in statuses) {
        const newObj = {}
        switch (property) {
          case 'queued':
            newObj.label = 'En cola'
            newObj.order = 0
            break
          case 'sent':
            newObj.label = 'Enviados'
            newObj.order = 1
            break
          case 'delivered':
            newObj.label = 'Entregados'
            newObj.order = 2
            break
          case 'read':
            newObj.label = 'Leidos'
            newObj.order = 3
            break
          case 'ignored':
            newObj.label = 'Ignorados'
            newObj.order = 4
            break
          case 'failed':
            newObj.label = 'Fallidos'
            newObj.order = 5
            break
        }
        newObj.quantity = this.dataSource.stats_send[property]
        newObj.status = property
        arr.push(newObj)
      }
      return arr.sort((a, b) => a.order - b.order)
    },
    /**
     * @return {Object} data usada para los graficos
     */
    chartdata() {
      const data = {
        labels: this.statuses.map((item) => item.label),
        datasets: [
          {
            data: this.statuses.map((item) => item.quantity),
            backgroundColor: [
              'rgba(194, 47, 179, 0.5)',
              'rgba(47, 194, 91, 0.5)',
              'rgba(255, 232, 24, 0.3)',
              'rgba(24, 144, 255, 0.5)',
              'rgba(191, 191, 191, 0.5)',
              'rgba(255, 58, 58, 0.5)',
            ],
            borderWidth: 0.5,
            borderColor: [
              'rgba(194, 47, 179, 0.5)',
              'rgba(47, 194, 91, 0.5)',
              'rgba(255, 232, 24, 0.3)',
              'rgba(24, 144, 255, 0.5)',
              'rgba(191, 191, 191, 0.5)',
              'rgba(255, 58, 58, 0.5)',
            ],
          },
        ],
      }
      return data
    },
  },
  methods: {
    ...mapActions([
      'exportValidStrategyRecords',
      'getCompanyStrategy',
      'getCompanyWallet',
    ]),

    /**
     * Obtiene la data por cada campaña
     */
    handleGetData() {
      this.getCompanyStrategy(this.dataSource._id)
      this.getCompanyWallet()
    },
  },
}
</script>

<style lang="sass" scoped>
.modal
  &__card
    border: 1px solid $gray_5
    border-radius: 4px
    padding: 12px
  &__subtitle
    margin: 16px 0px
  &__container-total
    margin-bottom: 20px
</style>
